/** PDF.js 5 uses URL.parse, which Safari added after our supported 17.4 baseline. */
export const ensurePdfUrlCompatibility = () => {
  if ('parse' in URL && typeof URL.parse === 'function') return
  Object.defineProperty(URL, 'parse', {
    configurable: true,
    writable: true,
    value: function parse(url: string | URL, base?: string | URL): URL | null {
      if (arguments.length === 0)
        throw new TypeError('URL.parse requires a URL')
      // Match native WebIDL string conversion, including conversion failures.
      const input = `${url}`
      const baseUrl = base === undefined ? undefined : `${base}`
      try {
        return new URL(input, baseUrl)
      } catch {
        return null
      }
    },
  })
}

ensurePdfUrlCompatibility()
